
import { Package, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { formatDistanceToNow } from 'date-fns';
import { Product } from '@/types/portfolio';

interface ProductHeaderProps {
  product: Product;
  portfolioId: string;
}

const getCertificationColor = (status: string) => {
  switch (status) {
    case "pending":
      return "bg-gray-100 text-gray-800";
    case "in_progress":
      return "bg-blue-100 text-blue-800";
    case "certified":
      return "bg-green-100 text-green-800";
    case "rejected":
      return "bg-red-100 text-red-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
};

export const ProductHeader = ({ product, portfolioId }: ProductHeaderProps) => {
  return (
    <div className="mb-6">
      <Link to={`/client/portfolios/${portfolioId}`}>
        <Button variant="outline" className="flex items-center gap-2 mb-4">
          <ArrowLeft className="h-4 w-4" />
          Back to Portfolio
        </Button>
      </Link>
      
      <div className="flex items-center gap-3 mb-2">
        <Package className="h-6 w-6 text-primary" />
        <h1 className="text-3xl font-bold">{product.name}</h1>
        <Badge className={getCertificationColor(product.certification_status)}>
          {product.certification_status.replace("_", " ")}
        </Badge>
        
        {product.certification_status === "certified" && (
          <img 
            src="/lovable-uploads/db5c9f04-b178-4abc-b8ed-9e09d1e7c292.png" 
            alt="Green Seal Certified" 
            className="h-8 w-auto ml-2" 
            title="Green Seal Certified"
          />
        )}
      </div>
      
      <p className="text-muted-foreground">
        Created {formatDistanceToNow(new Date(product.created_at), { addSuffix: true })}
      </p>
    </div>
  );
};
